import React from "react";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import { FEATURE_LIST_INTENT } from "utils/constants/feature";
import FeatureListHub from "./FeatureListHub";
import FeatureListProductOrder from "./FeatureListProductOrder";

const FeatureListSettings = ({ name, scrollTop }) => {
  const { values } = useFormikContext();

  const featureIntent = get(values, STATE_KEYS.EDITOR.FEATURE_INTENT);
  const contentProps = {
    name,
    scrollTop
  };
  const content =
    featureIntent === FEATURE_LIST_INTENT.PRODUCT_FEATURE_ORDER ? (
      <FeatureListProductOrder {...contentProps} />
    ) : (
      <FeatureListHub {...contentProps} />
    );

  return <div className="w-100">{content}</div>;
};

export default FeatureListSettings;
